import React, { FunctionComponent } from 'react'
import Button from '@material-ui/core/Button'
import { useTheme } from '@material-ui/core'
import useStyles from './ChatboxStyles'
import clsx from 'clsx'

const ChatTabButton: FunctionComponent<{ [key: string]: any } & { selected: boolean; onClick: any }> = (props) => {
    const { children, selected } = props

    const classes = useStyles(useTheme())
    const variant = selected ? 'contained' : 'outlined'

    if (selected) {
        return (
            <Button
                variant={variant}
                color="primary"
                size="small"
                className={clsx(classes.chatButton, classes.chatButtonFilled)}
                disableElevation
                {...props}
            >
                {children}
            </Button>
        )
    } else {
        return (
            <Button
                variant={variant}
                color="primary"
                size="small"
                className={classes.chatButton}
                disableElevation
                {...props}
            >
                {children}
            </Button>
        )
    }
}

export default ChatTabButton
